import { ShipmentListLeg } from "../models/ShipmentListLeg";

export class ShipmentList {
    Id: string;
    Tenant: number;
    OpenReceivablesInLocalCurrency: number;
    AccountedReceivablesInLocalCurrency: number;
    ProfitInLocalCurrency: number;
    EstimateProfitInLocalCurrency: number;
    OpenReceivablesInProfitCurrency: number;
    AccountedReceivablesInProfitCurrency: number;
    ProfitInProfitCurrency: number;
    EstimateProfitInProfitCurrency: number;
    OpenPayablesInLocalCurrency: number;
    AccountedPayablesInLocalCurrency: number;
    OpenPayablesInProfitCurrency: number;
    AccountedPayablesInProfitCurrency: number;
    LocalCustomsTransmissionsStatusCode: string;
    LocalCustomsTransmissionsStatusName: string;
    LocalCustomsTransmissionsStatusError: string;
    LocalCustomsTransmissionsStatusDate: Date;
    LocalCustomsSentByUserId: string;
    LocalCustomsSentByUserName: string;
    OperationalClosedByUserId: string;
    ComputedStatusId: string;
    ComputedStatusDate: Date;
    ComputedStatusName: string;
    ForeignPartnerCountryCode: string;
    CarrierNumber: string;
    CASSCode: string;
    IsFSRSent: boolean;
    LastFSRStatusRequestDate: Date;
    FHLStatusDate: Date;
    FWBStatusDate: Date;
    CarrierLastStatusCode: string;
    CarrierLastStatusName: string;
    CarrierLastStatusDate: Date;
    FNAReason: string;
    TransportModeId: string;
    DirectionId: string;
    ShipmentNumber: string;
    CreateDateTime: Date;
    LastStatusLogDate: Date;
    CustomFileId: string;
    IsShipmentTracking: boolean;
    CustomFileNumber: string;
    MainCarriageCarrierId: string;
    MainCarriageCarrierNumber: string;
    TruckNumber: string;
    MainCarriageCarrierCode: string;
    MainCarriageCarrierName: string;
    Agent: string;
    AgentComputed: string;
    AgentComputedName: string;
    CustomFieldId: string;
    FromPortId: string;
    FromPort: string;
    FromPortName: string;
    FromPortCountry: string;
    ToPortId: string;
    ToPort: string;
    ToPortName: string;
    ToPortCode: string;
    FromPortCode: string;
    ToPortCountry: string;
    AMSBL: string;
    House: string;
    ShipmentType: string;
    ShipmentTypeId: string;
    FollowUpType: string;
    FollowUpTypeId: string;
    FollowUpId: string;
    FollowUpDate: Date;
    FollowUpOwner: string;
    FollowUpOwnerId: string;
    CustomConnectToShipment: boolean;
    MainCarriageVesselId: string;
    MainCarriageVesselName: string;
    BookingConfirmationNumber: string;
    ShipmentViewId: string;
    BasketId: string;
    IsAccountingClosed: boolean;
    IsOperationalClosed: boolean;
    LastUpdate: Date;
    ComputedShipmentNumber: string;
    Field1Id: string;
    Field1: string;
    Field2: string;
    Field3: string;
    Field4: string;
    Field5: string;
    Field6: string;
    Field7: string;
    Field8: string;
    Field9: string;
    Field10: string;
    Field11: string;
    Field12: string;
    Field13: string;
    Field14: string;
    Field15: string;
    Field16: string;
    Field17: string;
    Field18: string;
    Field19: string;
    Field20: string;
    Field21: string;
    Field22: string;
    Field23: string;
    Field24: string;
    Field25: string;
    Field26: string;
    Field27: string;
    Field28: string;
    Field29: string;
    Field30: string;
    Field31: string;
    Field32: string;
    Field33: string;
    Field34: string;
    Field35: string;
    Field36: string;
    Field37: string;
    Field38: string;
    Field39: string;
    Field40: string;
    NewMessage: boolean;
    FollowUpNotes: string;
    IsAnyConversation: boolean;
    NumberOfShipments: number;
    MainCarriageETA: Date;
    MainCarriageATD: Date;
    ChargeableWeightInKG: number;
    LastModified: string;
    hasChanges: boolean;
    StatusId: string;
    StatusName: string;
    ExactStatusName: string;
    StatusDate: Date;
    StatusLocation: string;
    Master: string;
    DirectionName: string;
    TransportModeName: string;
    QuoteId: string;
    QuoteNumber: string;
    ShipmentReceivableStatusCode: string;
    ShipmentPayableStatusCode: string;
    ShipmentReceivableStatusName: string;
    ShipmentPayableStatusName: string;
    UpdatedByUserId: string;
    LastUpdateDate: Date;
    DepartmentId: string;
    BranchId: string;
    LongMaster: string;
    TrailerNumber: string;
    ProfitCurrencyCode: string;
    LocalCurrencyCode: string;
    NextLegCode: string;
    NextLegName: string;
    NextETD: Date;
    NextETA: Date;
    ShipmentLevelCode: string;
    ShipmentLevelName: string;
    MasterShipmentDataId: string;
    BranchName: string;
    MoveTypeName: string;
    GrossWeightInKG: number;
    VolumetricWeight: number;
    GrossWeightPerStorageDays: number;
    ChargeableWeight: number;
    GrossWeight: number;
    MasterShipmentNumber: string;
    Routing: string;
    AgentName: string;
    AgentReference1: string;
    AgentReference2: string;
    SearchFields: string;
    SearchFieldsText: string;
    CutoffDate: Date;
    MainCarriageFromPortId: string;
    MainCarriageToPortId: string;
    MainCarriageFromPortName: string;
    MainCarriageATA: Date;
    MainCarriageETD: Date;
    IncotermId: string;
    IncotermCode: string;
    FinalArrivalDate: Date;
    EstimatedFinalArrivalDate: Date;
    ActualFinalArrivalDate: Date;
    IssuingCarrierAgentId: string;
    AWBChargeAmount: number;
    AWBCommodityItemNumber: string;
    AWBPrint: boolean;
    FWBStatusCode: string;
    FHLStatusCode: string;
    FWBStatusName: string;
    FHLStatusName: string;
    MainCarriageFromPartnerId: string;
    MainCarriageFromAddressId: string;
    MainCarriageToPartnerId: string;
    MainCarriageToAddressId: string;
    MainCarriageCarrierPrefix: string;
    Transshipment1CarrierPrefix: string;
    Transshipment2CarrierPrefix: string;
    Transshipment3CarrierPrefix: string;
    MainCarriageFullCarrierNumber: string;
    Transshipment1FullCarrierNumber: string;
    Transshipment2FullCarrierNumber: string;
    Transshipment3FullCarrierNumber: string;
    AsAgreedFreight: boolean;
    AsAgreedOtherCharges: boolean;
    AccountNumber: string;
    ActivityDate: Date;
    ActivityTypeName: string;
    ActivityByUserName: string;
    IsManifestSentToAgent: boolean;
    AgentSharedManifestRef: string;
    Shipper: string;
    ShipperId: string;
    ShipperReference1: string;
    ShipperReference2: string;
    Consignee: string;
    ConsigneeReference1: string;
    ConsigneeReference2: string;
    FromCountryCode: string;
    ToCountryCode: string;
    TEU: number;
    ChargeableWeightUnitCode: string;
    PackagesQuantity: number;
    NumberOfPackages: number;
    NumberOfContainers: number;
    ConsigneeId: string;
    VolumeInCBM: number;
    BookingNumberOfPackages: number;
    OrderVolumetricWeight: number;
    OrderChargeableWeight: number;
    MainCarriageFromCity: string;
    MainCarriageFromCountryCode: string;
    MainCarriageToCity: string;
    MainCarriageToCountryCode: string;
    ProfitExchangeRate: number;
    AWBCurrencyCode: string;
    DeliveryOrder: string;
    ImportManifest: string;
    FreightLocationId: string;
    TransportDocumentNumber: string;
    CarrierTransportDocumentNumber: string;
    IsMultipleCommodities: boolean;
    FreelancerId: string;
    FreelancerAddressId: string;
    FreelancerContactId: string;
    SpecialServicesTypeId: string;
    SpecialServicesTypeName: string;
    FromPortCountryCode: string;
    FromPortCountryName: string;
    ToPortCountryCode: string;
    ToPortCountryName: string;
    AgentId: string;
    ARInvoiceIssued: boolean;
    CreditNoteIssued: boolean;
    FreightForwarderId: string;
    FreightForwarderName: string;
    ProductCode: string;
    IsOccurChange: boolean;
    CargonautFHLStatusCode: string;
    CargonautFHLStatusName: string;
    CargonautFHLStatusDate: Date;
    CargonautFWBStatusCode: string;
    CargonautFWBStatusName: string;
    CargonautFWBStatusDate: Date;
    NumberOfInsidePackages: number;
    NumberOfInsidePackagesDetails: string;
    CustomerId: string;
    CustomerName: string;
    CustomerReference1: string;
    CustomerReference2: string;
    ConsolidatorId: string;
    ConsolidatorName: string;
    ConsolidatorNote: string;
    ConsolidatorReference: string;
    ConsolidatorAddressId: string;
    ConsolidatorContactId: string;
    AccountManagerUserId: string;
    AccountManagerUserName: string;
    SalesmanUserId: string;
    // PreCarriageETD: Date;
    PreForwardingETD: Date;
    IsException: boolean;
    SalesmanUserName: string;
    CreatedByUserName: string;
    AirlinePrefix: string;
    ManifestReason: string;
    ManifestStatusCode: string;
    ExceptionDescription: string;
    ExceptionResolvedDescription: string;
    LastExceptionDescription: string;
    ExceptionDate: Date;
    HasException: boolean;
    IsMissingDocument: boolean;
    DocumentsSearchFields: string;
    ShipperName: string;
    ConsigneeName: string;
    ForwarderShipmentNumber: string;
    CustomerShipmentNumber: string;
    CustomsDeclarationNumber: string;
    ResultFromDocument: boolean;
    IncludesCustoms: boolean;
    DeclarationNumber: string;
    DeclarationDate: Date;
    CustomsClearanceDate: Date;
    IsCancelled: boolean;
    CancelledDate: Date;
    NoFreightFile: boolean;
    ShipmentMasterDataId: string;
    OperationalCloseDate: Date;
    AccountingCloseDate: Date;
    LastDocumentDateTime: Date;
    MainCarriageExpectedOrActual: Date;
    MainCarriageETAOrATA: string;
    MainCarriageFromPortCode: string;
    MainCarriageFromPortCountryName: string;
    MainCarriageFromPortCountryCode: string;
    MainCarriageToPortCode: string;
    MainCarriageToPortName: string;
    MainCarriageToPortCountryCode: string;
    MainCarriageToPortCountryName: string;
    PartnerLogoId: string;
    MissingDocumentsCount: number;
    MissingDocumentsCountWords: string;
    PartnerName: string;
    MissingDocsNames: string;
    NumberOfFollowUps: number;
    CustomerTenantNumber: number;
    MainCarriageFinalDestinationETA: Date;
    MainCarriageFinalDestinationATA: Date;
    DepartureArrivalFromDate: Date;
    DepartureArrivalToDate: Date;
    IsArchived: boolean;
    ArchivedText: string;
    RequestedDocumentsCount: number;
    IsRequestedDocuments: boolean;
    IsDigitalSignRequired: boolean;
    DescriptionOfGoods: string;
    Notes: string;
    IsImporterApprovalRequried: boolean;
    ApprovedByUserName: string;
    IsNewARInvoiceBlocked: boolean;
    OperationalDate: Date;
    MobileShipmentReference: string;
    ValueOfGoods: number;
    NumberOfHouses: number;
    ProrateReceivables: boolean;
    FreightRelease: Date;
    TerminalAvailable: Date;
    ISFNumber: string;
    ISFDate: Date;
    ITNumber: string;
    ITDate: Date;
    DocumentsClosingDate: Date;
    OBLTypeCode: string;
    ENSNumber: string;
    ENSDate: Date;
    RegistryDate: Date;
    IsAssembly: boolean;
    LastSharedEventId: string;
    LastSharedEventLocation: string;
    LastSharedEventNotes: string;
    LastSharedEventDate: Date;
    LastSharedEventName: string;
    GrossWeightPerTon: number;
    ManifestLastSharingDate: Date;
    MainCarriageFinalDestinationPortCode: string;
    WarehouseLegWarehouseId: string;
    WarehouseLegAddressId: string;
    WarehouseLegTerminalCode: string;
    WarehouseLegExpectedEntryDate: Date;
    WarehouseLegActualEntryDate: Date;
    WarehouseLegExpectedReleaseDate: Date;
    WarehouseLegActualReleaseDate: Date;
    WarehouseLegLastFreeDate: Date;
    WarehouseLegRemarks: string;
    WarehouseLegReference: string;
    WarehouseLegTerminalName: string;
    WarehouseLegEntryDate: Date;
    WarehouseLegReleaseDate: Date;
    WarehouseLegAddressCountryName: string;
    WarehouseLegAddressCountryCode: string;
    WarehouseLegVGMCutOffDate: Date;
    WarehouseLegCutOffDate: Date;
    FirstOperationalCloseDate: Date;
    FirstAccountingCloseDate: Date;
    AMSClosingDate: Date;
    UpdatedByPartner: string;
    INTTRASIError: string;
    INTTRASIStatusDate: Date;
    INTTRASIStatusCode: string;
    INTTRASIStatusName: string;
    EmergencyContactId: string;
    INTTRAContractNumber: string;
    INTTRAInstructions: string;
    INTTRAComments: string;
    INTTRADocumentQTY: number;
    SIHasAttachList: boolean;
    INTTRAIsFreighted: boolean;
    INTTRADocumentTypeCode: string;
    INTTRABookingTransStatusCode: string;
    INTTRABookingStatusCode: string;
    INTTRABookingTransStatusName: string;
    INTTRABookingStatusName: string;
    INTTRALastEBbookingSendDate: Date;
    From: string;
    To: string;
    Origin: string;
    LastFinalDestination: string;
    FirstPickupETD: Date;
    FirstPickupETA: Date;
    INTTRALastStatusDate: Date;
    INTTRABookingError: string;
    INTTRALastBookingResponse: string;
    Notify1Reference: string;
    Notify1Reference2: string;
    Notify2Reference: string;
    ShipperNotExporterReference: string;
    ConsigneeNotImporterReference: string;
    ProjectNumber: string;
    ContainerLastStatusDate: Date;
    BasicFreightId: string;
    DestinationPortChargesId: string;
    DestinationHaulageChargesId: string;
    AdditionalChargesId: string;
    FreightPayerId: string;
    FreightPayerAddressId: string;
    PreCarriageFromPortId: string;
    OnCarriageToPortId: string;
    Transshipment1ToPortId: string;
    Transshipment2ToPortId: string;
    Transshipment3ToPortId: string;
    IsDepositionRequired: boolean;
    ImporterDepositionRequestDetails: string;
    ForwarderPartnerId: string;
    ARInvoices: string;
    NotInvoicedReceivablesAmount: number;
    CreatedByPartner: string;
    FirstARInvoiceApprovalDate: Date;
    SLAC: string;
    CreatedFromDigital: boolean;
    ShipmentSubTypeId: string;
    ShipmentSubTypeName: string;
    IsDangerous: boolean;
    DangerousUnNumber: string;
    IsAccrualsApproved: boolean;
    AccrualsApprovalDate: Date;
    MainHarmonize: string;
    PreForwardingFromPortId: string;
    OnForwardingToPortId: string;
    IsStandalonePickupDelivery: boolean;
    ParentShipmentNumber: string;
    ParentShipmentType: string;
    ParentShipmentDirectionId: string;
    IsHTSMissing: boolean;
    PrivateLabelInvoiceNumber: string;
    RequestedFlightDate: Date;
    PrivateLabelIncludePickup: boolean;
    PrivateLabelIncludeDelivery: boolean;
    PlannedCargoReadyDate: Date;
    ApprovedCargoReadyDate: Date;
    HandlerUserId: string;
    HandlerUserName: string;
    StandalonePickupDeliveryId: string;
    GrossWeightUnitCode: string;
    OperationalStatusId: string;
    OperationalStatusName: string;
    BillingStatusId: string;

    // ShipmentAdditionalFields
    ShipperCity: string;
    ShipperCountryCode: string;
    ConsigneeCity: string;
    ConsigneeCountryCode: string;
    FirstPickupATD: Date;
    FirstPickupATA: Date;
    LastDeliveryATD: Date;
    LastDeliveryATA: Date;
    PackagesNumberLabel: string | null;

    ShipmentListLegs: ShipmentListLeg[];
    NextEstimated: string;

    OnCarriageATA: Date;
    OnCarriageATD: Date;
    OnCarriageETA: Date;
    OnCarriageETD: Date;
    HasOnCarriage: boolean;

    PreCarriageATA: Date;
    PreCarriageATD: Date;
    PreCarriageETA: Date;
    PreCarriageETD: Date;
    HasPreCarriage: boolean;

    ///////////////////////
    
    PreCarriageFromPortName: string | null;
    PreCarriageFromPortCountryCode: string | null;
    Transshipment1FromPortName: string | null;
    Transshipment1FromPortCountryCode: string | null;
    Transshipment2FromPortName: string | null;
    Transshipment2FromPortCountryCode: string | null;
    Transshipment3FromPortName: string | null;
    Transshipment3FromPortCountryCode: string | null;
    OnCarriageFromPortName: string | null;
    OnCarriageFromPortCountryCode: string | null;
}